import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { appConfig } from '../../config';

const Services = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section" id="services">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9}>
                            <div className="text-center mb-5">
                                <h1 className="mb-3 ff-secondary fw-semibold lh-base">
                                    {t('t-control-working-hours')}
                                </h1>
                                {/* <p className="text-muted">To achieve this, it would be necessary to have uniform grammar,
                                    pronunciation and more common words. If several languages coalesce the grammar</p> */}
                            </div>
                        </Col>
                    </Row>

                    <Row className="g-3">
                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-pencil-ruler-2-line fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">{t('t-fact')}</h5>
                                    <p className="text-muted my-3 ff-secondary">{t('t-fact-desc')}</p>
                                    <div>
                                        <Link to="/services/fact" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-table-line fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">{t('t-schedule')}</h5>
                                    <p className="text-muted my-3 ff-secondary">{t('t-schedule-desc')}</p>
                                    <div>
                                        <Link to="/services/table" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-attachment-2 fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">{t('t-tasks')}</h5>
                                    <p className="text-muted my-3 ff-secondary">{t('t-tasks-desc')}</p>
                                    <div>
                                        <Link to="/services/tasks" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-computer-line fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">
                                        {t('t-control-remote')}
                                    </h5>
                                    <p className="text-muted my-3 ff-secondary">
                                        {t('t-control-remote-desc')}
                                    </p>
                                    <div>
                                        <Link to="/services/controll" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-currency-line fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">
                                        {t('t-salary')}
                                    </h5>
                                    <p className="text-muted my-3 ff-secondary">
                                        {t('t-salary-desc')}
                                    </p>
                                    <div>
                                        <Link to="/services/salary" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="bx bx-face fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">
                                        {t('t-face-id')}
                                    </h5>
                                    <p className="text-muted my-3 ff-secondary">
                                        {t('t-face-id-desc')}
                                    </p>
                                    <div>
                                        <Link to="/services/face" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="bx bx-bot fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">
                                        {t('t-mobile-app')}
                                    </h5>
                                    <p className="text-muted my-3 ff-secondary">
                                        {t('t-mobile-app-desc')}
                                    </p>
                                    <div>
                                        <Link to="/services/bot" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} sm={6}>
                            <div className="d-flex p-3">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm icon-effect">
                                        <div className="avatar-title bg-transparent text-success rounded-circle">
                                            <i className="ri-google-fill fs-36"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-18">{t('t-api')}</h5>
                                    <p className="text-muted my-3 ff-secondary">
                                        {t('t-api-desc').split('{appName}')[0]}
                                        <span className="fw-semibold">{appConfig.appName}</span>
                                        {t('t-api-desc').split('{appName}')[1].split('{medplus}')[0]}
                                        <span className='text-primary fw-semibold'> med</span><span className='text-danger fw-semibold fs-larger'>plus </span>
                                        {t('t-api-desc').split('{appName}')[1].split('{medplus}')[1]}
                                    </p>
                                    <div>
                                        <Link to="/services/api" className="fs-13 fw-medium">{t('t-know-more')} <i className="ri-arrow-right-s-line align-bottom"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Services;